<mat-carousel class="additional-service" timings="2000ms ease-in" [autoplay]="false" color="accent" [interval]="15000"
    maxWidth="auto" [loop]="true" [hideArrows]="false" [hideIndicators]="false" [useKeyboard]="true"
    [useMouseWheel]="false">
    <mat-carousel-slide *ngFor="let item of premiumChannels; let i = index" [hideOverlay]="true">
        <div class="plans-box-container m-top-p">
            <div *ngFor="let channel of premiumChannels[i]; let j = index" class="addservicechoices"
                [ngClass]="{'selectedON': this.isSelected(channel.idChannel)}">
                <div class="overallpadded-c-i">
                    <div class="basicrow b-b-gray channel-name">
                        {{channel.name}}
                    </div>
                    <div class="box b-b-gray">
                        <div class="tabcell">
                            {{channel.description}}
                        </div>
                    </div>
                    <div class="inneraddservice-title roboto-b vcenter">
                        <div class="tabcell">
                            Precio Mensual
                        </div>
                    </div>
                    <div class="addservice-numb">
                        {{channel.price | currency}}
                    </div>
                    <div class="box-1">
                        <div class="roboto-m ">
                            Términos y condiciones <a class="ClaroTv">Claro</a><a class="tvmas">tv+</a>
                        </div>
                        <div class="check-terms">
                            <mat-checkbox [disabled]="this.isSelected(channel.idChannel)" [(ngModel)]="channel.check"
                                [color]="'warn'"><a target="_blank" rel="noopener noreferrer" href="/iptv_terms" class="linkdefs">Aceptar terminos
                                    y
                                    condiciones.</a></mat-checkbox>
                        </div>
                    </div>
                    <div *ngIf="!this.isSelected(channel.idChannel)" class="innerservice-btn vcenter"
                        [ngClass]="{'deleteItem': this.isSelected(channel.idChannel)}">
                        <div class="tabcell" (click)="this.addItem(channel.idChannel,channel.check)">
                            Agregar
                        </div>
                    </div>
                    <div *ngIf="this.isSelected(channel.idChannel)" class="innerservice-btn vcenter deleteItem">
                        <div class="tabcell" (click)="this.removeItem(channel.idChannel,i,j)">
                            Eliminar
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-carousel-slide>
</mat-carousel>
